var React = require('react');

function Error (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"  all"),React.createElement("g",{"data-name":"Zoom In","key":1},React.createElement("g",{"data-name":"Calendar"},[React.createElement("path",{"d":"M76.7 58H23.3V42H76.7V58Z","key":0}),React.createElement("rect",{"x":"23.3","y":"42","width":"53.4","height":"16","key":1}),React.createElement("path",{"d":"M50 0a50 50 0 1 0 50 50A50 50 0 0 0 50 0Zm0 92.2A42.2 42.2 0 1 1 92.2 50 42.2 42.2 0 0 1 50 92.2Z","key":2})]))]);
}

Error.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 100 100"};

module.exports = Error;

Error.default = Error;
